import { Reducer } from 'redux';
import { ClassifierTypeState, ClassifierTypeActionTypes, GET_CLASSIFIER_TYPES_LIST } from '../types/classifiertypes.types';

const initialState: ClassifierTypeState = {
  classifierTypes: []
};

export const classifierTypesReducer: Reducer<ClassifierTypeState> = (
  state: ClassifierTypeState = initialState, action
) => {
  switch ((action as ClassifierTypeActionTypes).type) {
    case GET_CLASSIFIER_TYPES_LIST:
      return {
        classifierTypes: action.payload.page.content
      };
    default:
      return state;
  }
};
